<script>
import ENUMS from '@shared/messages/enums.json';

export default {
  messages: {
    statusClass: ENUMS.trainingStatusClass,
  },
  data() {
    return {
      isFetching: false,
    };
  },
  validations: {
  },
  computed: {
    authStore() {
      return this.$store.getters['auth/store'];
    },
  },
  methods: {
    getData() {
      this.isFetching = true;
      this.$store.dispatch('trainings/fetch')
        .finally(() => (this.isFetching = false));
    },
  },
  created() {
    this.getData();
  },
};
</script>

<template>
  <form @submit.prevent="!isFetching && getData()">
    <b-skeleton v-if="isFetching" height="400" />
    <template v-else>
      <ul v-if="$store.state.trainings.list.data.length > 0">
        <li
          v-for="training in $store.state.trainings.list.data"
          :key="training.uuid"
          class="box flex-between-center"
        >
          <div>
            <p>
              <b-icon icon="chalkboard-teacher" class="mr-2" />
              Formation : <b>{{ training.name }}</b>
              <br>
              <span class="tag mt-2">
                <b-icon
                  class="mr-1 is-size-9"
                  icon="circle"
                  :type="$options.messages.statusClass[training.status]"
                />
                <span v-t="`trainings.status.${training.status}`" />
              </span>
            </p>
          </div>
          <b-button class="ml-5" @click="$emit('choose', training)">
            Sélectionner
          </b-button>
        </li>
      </ul>
      <p v-else class="notification">
        Aucune formation.
      </p>
    </template>
  </form>
</template>
